import React from 'react'

const Manual_configuracion_de_item = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     DELIVERECT - Configuración de Ítem
     </h2>
     <iframe
          src="https://scribehow.com/embed/DELIVERECT__Configuracion_de_Item__GIx9pvE2QhKFK03RyM-RwQ?as=scrollable"
          className="scribe-iframe-deliverect-2"
          width="100%"
          height="2800"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_configuracion_de_item